import { TableContainer, Typography } from "@mui/material";
import { Box } from "@mui/system";
import CollapsibleTable from "./CollapsibleTable";

export default function ResourceTable({ data }) {
    data = data && Object.values(data).filter((ety) => ety.cdn);

    return (
        data && (
            <Box sx={{ marginBottom: 2 }}>
                <Typography sx={{
                    fontFamily: "montserrat",
                    fontSize: "2rem",
                    fontWeight: 700,
                    marginTop: 0.5,
                    marginBottom: 1,
                    marginX: 2,
                }}>
                    Resources Delivered By CDNs
                </Typography>
                <TableContainer sx={{
                    backgroundColor: "#f5f5f5",
                    borderRadius: "2rem",
                }}>
                    <CollapsibleTable
                        data={data}
                        heads={["Domain", "Provider", "IP", "Organization"]}
                        headKeys={["key", "provider", "ip", "organization"]}
                        headTransforms={["", "capitalize", "", "uppercase"]}
                        childFunc={({ resources, asn, host }) => (
                            <Box sx={{ margin: 1 }}>
                                <Typography variant="subtitle1" component="div">Resources</Typography>
                                {asn && <Typography variant="caption" component="div">
                                    ASN: {asn}
                                </Typography>}
                                {host && <Typography variant="caption" component="div">
                                    Hostname: {host}
                                </Typography>}
                                <CollapsibleTable
                                    data={resources}
                                    heads={["URL", "Location", "Cache Status", "PoP"]}
                                    headKeys={["key", "location", "cacheStatus", "pop"]}
                                    headTransforms={["", "capitalize", "uppercase"]}
                                    cellsx={{ color: "#555", fontSize: "small", fill: "#555" }}
                                    size="small"
                                    childFunc={({ cacheControl, reserves }) => (
                                        <Box sx={{ margin: 1 }}>
                                            <Typography variant="subtitle2" component="div" color="#555">Detail</Typography>
                                            {cacheControl && <Typography variant="caption" component="div" color="#555">Cache Control: {cacheControl}</Typography>}
                                            {reserves && reserves.map(({ name, value }, idx) => (
                                                <Typography variant="caption" component="div" key={idx} color="#555" textTransform="capitalize">{name}: {value}</Typography>
                                            ))}
                                        </Box>
                                    )}
                                />
                            </Box>
                        )}
                    />
                </TableContainer>
            </Box>
        )
    );
};